import type { QueryClient } from '@tanstack/react-query'
import { createRootRouteWithContext, HeadContent, Outlet } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

interface RouterContext {
	queryClient: QueryClient
}

export const Route = createRootRouteWithContext<RouterContext>()({
	head: () => ({
		meta: [{ title: 'Jobilla' }],
	}),
	component: RootLayout,
	notFoundComponent: NotFoundScreen,
})

function RootLayout() {
	return (
		<>
			<HeadContent />
			<Outlet />
		</>
	)
}

function NotFoundScreen() {
	// A token-less/unmatched URL has no campaign context, so this renders in the
	// visitor's browser-detected language (see i18n.ts). Reuses the booking
	// not-found copy. useSuspense: false so it degrades to the fallback language
	// rather than suspending with no boundary at the root.
	const { t } = useTranslation('booking', { useSuspense: false })

	return (
		<div className="flex min-h-screen flex-col items-center justify-center gap-2 text-center">
			<p className="text-lg font-medium text-grey-800">{t('terminal.not_found.title')}</p>
			<p className="max-w-sm text-sm text-grey-500">{t('terminal.not_found.body')}</p>
		</div>
	)
}
